export function appFunc() {
    var showDrawer = false; // 옵션창 상태정보
}